
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { useTheme } from '../theme/ThemeProvider';

interface MarkdownRendererProps {
  content: string;
}

interface CodeProps {
  node?: any;
  inline?: boolean;
  className?: string;
  children: React.ReactNode;
}

export function MarkdownRenderer({ content }: MarkdownRendererProps) {
  const { theme } = useTheme();
  
  return (
    <div className="prose dark:prose-invert prose-slate max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          code({node, inline, className, children, ...props}: CodeProps) {
            const match = /language-(\w+)/.exec(className || '');
            return !inline && match ? (
              <SyntaxHighlighter
                style={oneDark}
                language={match[1]}
                PreTag="div"
                {...props}
                className="rounded-md overflow-hidden border border-muted"
                customStyle={{
                  backgroundColor: theme === 'dark' ? '#1e293b' : '#f1f5f9',
                  borderRadius: '0.375rem',
                  padding: '1rem',
                  border: `1px solid ${theme === 'dark' ? '#334155' : '#e2e8f0'}`,
                  fontSize: '0.875rem',
                  lineHeight: '1.5',
                  overflow: 'auto',
                  marginTop: '1rem',
                  marginBottom: '1rem',
                }}
                codeTagProps={{
                  style: {
                    color: theme === 'dark' ? '#e2e8f0' : '#334155'
                  }
                }}
              >
                {String(children).replace(/\n$/, '')}
              </SyntaxHighlighter>
            ) : (
              <code 
                className={`${className} px-1 py-0.5 rounded-sm bg-muted`} 
                style={{ 
                  backgroundColor: theme === 'dark' ? '#334155' : '#f1f5f9',
                  color: theme === 'dark' ? '#e2e8f0' : '#334155'
                }}
                {...props}
              >
                {children}
              </code>
            );
          }
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
